module.exports = __webpack_public_path__ + "img/1-10.4651b51b.svg";